import React, { useEffect, useState } from "react"
import api from "API/Api"
import { Link } from "react-router-dom"
import { Table, Col, Row } from "reactstrap"
import loader from "./../../assets/loading/loader.gif"
import PageLoader from "./../../assets/loading/pageLoad1.gif"
import { getInfo } from "API/UserAccess"
import { usePermissions } from "API/PermissionContext"

const BillCustomization = () => {
  const { canEdit, MODULE } = usePermissions()
  const MID = MODULE.BILL_CUSTOMIZATION
  const [companies, setCompanies] = useState([])
  const [pageLoad, setPageLoad] = useState(true)
  const [permission, setPermission] = useState("")
  const [search, setSearch] = useState("")

  useEffect(() => {
    fetchData()
  }, [])
  const fetchData = async () => {
    try {
      const resp = await api.get("companies")
      const perm = await getInfo()
      if (perm && perm.length > 0) setPermission(perm[0])
      setCompanies(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (error) {
      console.error("Failed to fetch companies:", error)
    }
    setPageLoad(false)
  }

  return (
    <>
      {pageLoad ? (
        <div className="pageLoader">
          <img src={PageLoader} />{" "}
        </div>
      ) : (
        <div className="dashBody">
          <div className="font-size-18 mb-0 dashHeader">
            <Row>
              <Col md={9}>
                <h4>Bill Cusomization</h4>
              </Col>
              <Col md={3}>
                <div className="input-group">
                  <div className="input-group-text">
                    <i className="fas fa-search"></i>
                  </div>
                  <input
                    type="text"
                    onChange={e => setSearch(e.target.value)}
                    value={search}
                    className="form-control"
                    placeholder="Filter by Client Company Name"
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0 dairyTbl" id="canTypes">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Company Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {companies.length > 0 ? (
                  companies
                    .filter(item =>
                      item.name.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((company, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{company.name}</td>
                        <td>
                          {canEdit(MID) && <Link
                              className="pencilIcon"
                              to={"/add-bill-customization/" + company.id}
                            >
                              <i className="fas fa-pen-square fa-2x"></i>
                            </Link>}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td colSpan={3} style={{textAlign:'center', padding:'20px'}}>
                      No companies found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  )
}

export default BillCustomization
